// OrganizationService.js

import api from "../common/api";
import { organizations } from "../common/endPoints";

const OrganizationService = {
  async getOrganization() {
    return await api.get(organizations);
  },

  async updateOrganization(params) {
    // Check if params contains a file (organization_document)
    const hasFile = params instanceof FormData || 
                    (params.organization && params.organization.organization_document instanceof File);

    if (hasFile) {
      // If it's not already FormData, convert it
      let formData;
      if (params instanceof FormData) {
        formData = params;
      } else {
        formData = new FormData();
        Object.entries(params.organization || {}).forEach(([key, value]) => {
          if (value instanceof File) {
            formData.append(`organization[${key}]`, value);
          } else if (value !== null && value !== undefined) {
            formData.append(`organization[${key}]`, value);
          }
        });
      }
      return await api.put(organizations, formData);
    } else {
      return await api.put(organizations, params);
    }
  },
};

export default OrganizationService;
